module.exports = __webpack_public_path__ + "img/TOP.8d701522.jpg";